import React, { useEffect } from "react";
import SaitGrid from "../atomic/SaitGrid";
import Box from "@mui/material/Box";

export default function SimpleGrid(props) {
	const [rows, setRows] = React.useState([]);
	const [page, setPage] = React.useState(0);

	const [gridFilters, setGridFilters] = React.useState([]);

	useEffect(() => {
		setRows(props.rows || []);
	}, [props.rows]);

	const handlePageChanged = (newPage) => {
		if (newPage !== page) {
			props.setPage(newPage);
			setPage(newPage);
		}
	};

	const styleGrow = {
		flexGrow: 1,
		display: "flex",
		...props.sx,
	};

	const styleHeight = {
		flexGrow: 1,
		maxHeight: props.height,
		display: "flex",
		...props.sx,
	};

	return (
		<Box sx={props.height ? styleHeight : styleGrow}>
			<SaitGrid
				{...props}
				originalRows={props.rows || []}
				rows={rows}
				setRows={setRows}
				title={props.gridParams.title}
				columns={props.gridParams.columns}
				selection={props.gridParams.selection}
				pageSize={props.pageSize || 100}
				page={page}
				rowCount={props.rows ? props.rows.length : 0}
				noStandardToolbar={props.noStandardToolbar}
				hideFooter={props.hideFooter || false}
				handlePageChanged={handlePageChanged}
				gridFilters={gridFilters}
				changeGridFilters={setGridFilters}
				filterMode={"client"}
				paginationMode={"client"}
				sortingMode={"client"}
			/>
		</Box>
	);
}
